import ExcelJS from 'exceljs';

export interface LedgerExportColumn {
  header: string;
  value: (row: any) => any;
  width?: number;
  money?: boolean;
}

export interface LedgerExportOptions {
  title: string;
  fileName: string;
  filterSummary: string;
  generated?: Date;
  summary?: [string, any, boolean?][];   // label, value, is money
  columns: LedgerExportColumn[];
  rows: any[];
}

const MONEY = '#,##0.00;[Red]-#,##0.00';

// 7.1.25: every export carries the filters used and when it was generated
export async function exportLedgerExcel(o: LedgerExportOptions): Promise<void> {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(o.title.substring(0, 31));

  ws.addRow([o.title]).font = { bold: true, size: 14 };
  ws.addRow(['Filters', o.filterSummary || 'None']);
  ws.addRow(['Generated', (o.generated || new Date()).toLocaleString()]);
  for (const [label, value, money] of o.summary || []) {
    const row = ws.addRow([label, value]);
    if (money) row.getCell(2).numFmt = MONEY;
  }
  ws.addRow([]);

  ws.addRow(o.columns.map(c => c.header)).font = { bold: true };
  for (const r of o.rows) ws.addRow(o.columns.map(c => c.value(r) ?? ''));

  o.columns.forEach((c, i) => {
    const col = ws.getColumn(i + 1);
    col.width = Math.max(c.width || 14, i === 0 ? 16 : 0);
    if (c.money) col.numFmt = MONEY;
  });

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${o.fileName}-${new Date().toISOString().substring(0, 10)}.xlsx`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const dateOnly = (v: any) => (v ? String(v).substring(0, 10) : '');
